
export default function ProcessSection() {
  const processSteps = [
    {
      step: '01',
      icon: 'ri-chat-3-line',
      title: 'Consultation',
      description: 'We begin with a detailed discussion to understand your project requirements, timeline, and specific objectives.'
    },
    {
      step: '02',
      icon: 'ri-pencil-ruler-2-line',
      title: 'Design',
      description: 'Our expert team creates precise technical drawings and models using industry-leading software and methodologies.'
    },
    {
      step: '03',
      icon: 'ri-search-eye-line',
      title: 'Review',
      description: 'Collaborative review process with your team to ensure accuracy, completeness, and alignment with project goals.'
    },
    {
      step: '04',
      icon: 'ri-rocket-line',
      title: 'Delivery',
      description: 'Final deliverables provided in your preferred format, complete with documentation and ongoing support.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#212026] mb-4">
            Our Proven Process
          </h2>
          <p className="text-xl text-[#889d8f] max-w-3xl mx-auto">
            A systematic approach that ensures quality, efficiency, and client satisfaction in every project
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {processSteps.map((step, index) => (
            <div key={index} className="relative">
              {/* Step Number */}
              <div className="text-center mb-6">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#e18033] rounded-full text-white font-bold text-xl mb-4">
                  {step.step}
                </div>
                <div className="w-12 h-12 bg-[#dbcfbf]/30 rounded-lg flex items-center justify-center mx-auto">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${step.icon} text-[#e18033] text-2xl`}></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="text-center">
                <h3 className="text-lg font-bold text-[#212026] mb-3">
                  {step.title}
                </h3>
                <p className="text-[#889d8f] leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Connector Line */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-[#dbcfbf]/30 transform -translate-y-1/2 z-0">
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
                    <div className="w-3 h-3 bg-[#dbcfbf]/50 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
